export default __webpack_public_path__ + "3d675f30d8df12f0f776a52441397f98.svg";